import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLanguageFromHost } from '../utilities/getLanguageFromHost';

import en from './en.json';
import es from './es.json';

function international() {
  const lang = getLanguageFromHost();
  i18n.use(initReactI18next).init(
    {
      interpolation: {
        escapeValue: false,
        prefix: '{',
        suffix: '}',
      },
      lng: lang,
      resources: {
        en: {
          translation: en,
        },
        es: {
          translation: es,
        },
      },
    },
    (err) => {
      if (err) {
        throw new Error(err);
      }
    }
  );

  return i18n;
}

export default international;
